export default {
  type: 'menu',
  code: '19000000',
  create: {
    type: 'btns',
    code: '19010000'
  }
}
